var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _circle2, _path14, _g, _path15, _path16, _path17, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSewing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b5c4e0",
    d: "M20,52h-9v5c0,1.105,0.895,2,2,2h5c1.105,0,2-0.895,2-2V52z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M18,60h-5c-1.654,0-3-1.346-3-3v-5c0-0.553,0.447-1,1-1h9c0.553,0,1,0.447,1,1v5 C21,58.654,19.654,60,18,60z M12,53v4c0,0.552,0.448,1,1,1h5c0.552,0,1-0.448,1-1v-4H12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5c4e0",
    d: "M51,52h-9v5c0,1.105,0.895,2,2,2h5c1.105,0,2-0.895,2-2V52z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M49,60h-5c-1.654,0-3-1.346-3-3v-5c0-0.553,0.447-1,1-1h9c0.553,0,1,0.447,1,1v5 C52,58.654,50.654,60,49,60z M43,53v4c0,0.552,0.448,1,1,1h5c0.552,0,1-0.448,1-1v-4H43z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5c4e0",
    d: "M52,18v9h5c1.105,0,2-0.895,2-2v-5c0-1.105-0.895-2-2-2H52z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M57,28h-5c-0.553,0-1-0.447-1-1v-9c0-0.553,0.447-1,1-1h5c1.654,0,3,1.346,3,3v5 C60,26.654,58.654,28,57,28z M53,26h4c0.552,0,1-0.448,1-1v-5c0-0.552-0.448-1-1-1h-4V26z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#85cbf8",
    d: "M55,19v34c0,1.1-0.9,2-2,2H9c-1.1,0-2-0.9-2-2v-8c0-3.31,2.69-6,6-6h15c1.94,0,3.68-0.78,4.95-2.05C34.22,35.68,35,33.94,35,32c0-3.87-3.13-7-7-7h-3.89c-0.86,0-1.63,0.55-1.9,1.37l-0.75,2.26c-0.28,0.82-1.04,1.37-1.9,1.37H12c-1.1,0-2-0.9-2-2v-9c0-1.88,0.87-3.57,2.23-4.67C13.26,13.5,14.57,13,16,13h33c1.43,0,2.74,0.5,3.77,1.33C54.13,15.43,55,17.12,55,19z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ace3ff",
    d: "M52.77,14.33C52.22,15.89,50.74,17,49,17H16c-1.74,0-3.22-1.11-3.77-2.67C13.26,13.5,14.57,13,16,13h33C50.43,13,51.74,13.5,52.77,14.33z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#7bbeeb",
    d: "M55,47H7v6.114C7,54.156,7.844,55,8.886,55h44.229C54.156,55,55,54.156,55,53.114V47z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M53,56H9c-1.654,0-3-1.346-3-3v-8c0-3.859,3.141-7,7-7h15c3.309,0,6-2.691,6-6s-2.691-6-6-6h-3.892c-0.431,0-0.812,0.274-0.949,0.684l-0.755,2.266C21.995,30.176,20.852,31,19.559,31H12c-1.654,0-3-1.346-3-3v-9c0-3.859,3.141-7,7-7h33c3.859,0,7,3.141,7,7v34C56,54.654,54.654,56,53,56z M13,40c-2.757,0-5,2.243-5,5v8c0,0.552,0.448,1,1,1h44c0.552,0,1-0.448,1-1V19c0-2.757-2.243-5-5-5H16c-2.757,0-5,2.243-5,5v9c0,0.552,0.448,1,1,1h7.559c0.431,0,0.812-0.274,0.949-0.684l0.755-2.266C21.672,24.824,22.815,24,24.108,24H28c4.411,0,8,3.589,8,8s-3.589,8-8,8H13z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M16,35c-0.553,0-1-0.447-1-1v-4c0-0.553,0.447-1,1-1s1,0.447,1,1v4C17,34.553,16.553,35,16,35z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M18,35h-4c-0.553,0-1-0.447-1-1s0.447-1,1-1h4c0.553,0,1,0.447,1,1S18.553,35,18,35z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 23,
    r: 3,
    fill: "#e3f2ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M47,27c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S49.206,27,47,27z M47,21c-1.103,0-2,0.897-2,2 s0.897,2,2,2s2-0.897,2-2S48.103,21,47,21z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 36,
    r: 5,
    fill: "#e3f2ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M45,42c-3.309,0-6-2.691-6-6s2.691-6,6-6s6,2.691,6,6S48.309,42,45,42z M45,32c-2.206,0-4,1.794-4,4 s1.794,4,4,4s4-1.794,4-4S47.206,32,45,32z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 7,
    x: 36,
    y: 6,
    fill: "#ffeb9b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M42,14h-6c-0.553,0-1-0.447-1-1V6c0-0.553,0.447-1,1-1h6c0.553,0,1,0.447,1,1v7 C43,13.553,42.553,14,42,14z M37,12h4V7h-4V12z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M39,7c-0.553,0-1-0.447-1-1V3c0-0.553,0.447-1,1-1s1,0.447,1,1v3C40,6.553,39.553,7,39,7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M47,14c-0.553,0-1-0.447-1-1V8c0-0.553,0.447-1,1-1s1,0.447,1,1v5C48,13.553,47.553,14,47,14z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M19,14c-0.553,0-1-0.447-1-1v-3c0-0.553,0.447-1,1-1s1,0.447,1,1v3C20,13.553,19.553,14,19,14z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M11,49c-0.553,0-1-0.447-1-1v-2c0-0.553,0.447-1,1-1s1,0.447,1,1v2C12,48.553,11.553,49,11,49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M16,49c-0.553,0-1-0.447-1-1v-2c0-0.553,0.447-1,1-1s1,0.447,1,1v2C17,48.553,16.553,49,16,49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M21,49c-0.553,0-1-0.447-1-1v-2c0-0.553,0.447-1,1-1s1,0.447,1,1v2C22,48.553,21.553,49,21,49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M26,49c-0.553,0-1-0.447-1-1v-2c0-0.553,0.447-1,1-1s1,0.447,1,1v2C27,48.553,26.553,49,26,49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M31,49c-0.553,0-1-0.447-1-1v-2c0-0.553,0.447-1,1-1s1,0.447,1,1v2C32,48.553,31.553,49,31,49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M36,49c-0.553,0-1-0.447-1-1v-2c0-0.553,0.447-1,1-1s1,0.447,1,1v2C37,48.553,36.553,49,36,49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M41,49c-0.553,0-1-0.447-1-1v-2c0-0.553,0.447-1,1-1s1,0.447,1,1v2C42,48.553,41.553,49,41,49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M46,49c-0.553,0-1-0.447-1-1v-2c0-0.553,0.447-1,1-1s1,0.447,1,1v2C47,48.553,46.553,49,46,49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M51,49c-0.553,0-1-0.447-1-1v-2c0-0.553,0.447-1,1-1s1,0.447,1,1v2C52,48.553,51.553,49,51,49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSewing);
export default __webpack_public_path__ + "static/media/Sewing.144cfacee61761a419c0af4299f5db31.svg";
export { ForwardRef as ReactComponent };